module.exports = __webpack_public_path__ + "static/media/objective2.0911d3c5.svg";